import { takeEvery, fork, put, all, call, select } from "redux-saga/effects";

import {
  GET_TICKET_LIST,
  GET_TICKET_FORMS,
  SET_TICKET_FILTER,
  SET_TICKET_SORT,
  NEXT_TICKET_PAGE,
  PREV_TICKET_PAGE,
} from "./actionTypes";

import {
  getTicketFormsError,
  getTicketFormsSuccess,
  getTicketListError,
  getTicketListSuccess,
} from "./actions";

import axios from "axios";

function* getListForms() {
  try {
    const response = yield call(axios.get, "/operator-area/tickets/forms");

    yield put(getTicketFormsSuccess(response.data.data));
  } catch (error) {
    let message =
      "Sorry! something went wrong, please contact our support team";
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(getTicketFormsError(message));
  }
}

function* getTicketList() {
  const state = yield select();

  const { filter, pagination, sort } = state.TicketsOperatorArea;
  let lastTab = undefined;
  if (filter?.tabs?.length > 0) {
    lastTab = filter?.tabs[0]?.value;
  }

  try {
    const response = yield call(axios.get, "/operator-area/tickets", {
      params: {
        protocol: filter?.protocol?.trim(),
        skills: filter?.skills_id?.map((item) => item.value).join(","),
        agent: filter?.agents_id?.value,
        client: filter?.client?.trim(),
        personal_information: filter.personal_information?.value?.trim(),
        personal_information_types: filter.personal_information?.value
          ? filter.personal_information?.types.join(",")
          : null,
        dateStart: new Date(
          filter.date?.[0]?.setHours(0, 0, 0, 0)
        ).toISOString(),
        dateEnd: new Date(
          filter.date?.[1]?.setHours(23, 59, 59, 999)
        ).toISOString(),
        sort: sort.path,
        order: sort.order,
        page: pagination.current,
        tab: lastTab,
        limit: pagination.pageSize,
      },
      paramsSerializer: (params) => {
        return Object.keys(params)
          .map((key) => {
            if (params[key])
              return (
                encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
              );
            return null;
          })
          .filter((item) => item)
          .join("&");
      },
    });
    if (response.status >= 200 || response.status <= 299) {
      yield put(
        getTicketListSuccess(response.data?.data, response.data?.totalItems)
      );
    } else throw response.data;
  } catch (error) {
    let message =
      "Sorry! something went wrong, please contact our support team";
    console.log(error);
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message =
              error.response.data.message?.length > 0
                ? error.response.data.message[0]
                : error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(getTicketListError(message));
  }
}

export function* watchTicketList() {
  yield takeEvery(GET_TICKET_LIST, getTicketList);
}

export function* watchTicketListFilter() {
  yield takeEvery(SET_TICKET_FILTER, getTicketList);
}

export function* watchTicketNextPage() {
  yield takeEvery(NEXT_TICKET_PAGE, getTicketList);
}

export function* watchTicketPrevPage() {
  yield takeEvery(PREV_TICKET_PAGE, getTicketList);
}

export function* watchTicketForms() {
  yield takeEvery(GET_TICKET_FORMS, getListForms);
}

export function* watchTicketSort() {
  yield takeEvery(SET_TICKET_SORT, getTicketList);
}

function* authSaga() {
  yield all([
    fork(watchTicketList),
    fork(watchTicketForms),
    fork(watchTicketListFilter),
    fork(watchTicketNextPage),
    fork(watchTicketPrevPage),
    fork(watchTicketSort),
  ]);
}

export default authSaga;
